import React from "react";

import { InvoiceModel } from "api";
import ContractTabTable from "components/SortableTable/SortableStripedTable";

export const invoicesColumns: ColumnDefinition<InvoiceModel>[] = [
  {
    property: "invoiceNumber",
    sortKey: "DocumentNumber",
    columnLabel: "Invoice #",
  },
  {
    property: "releaseNumber",
    sortKey: "ReleaseNumber",
    columnLabel: "Release #",
  },
  {
    property: "dueDate",
    sortKey: "DocDueDate",
    columnLabel: "Due Date",
  },
  {
    property: "amountDue",
    sortKey: "AmountDue",
    columnLabel: "Amount Due",
  },
  {
    property: "poNumber",
    sortKey: "NumAtCard",
    columnLabel: "PO #",
  },
];

const InvoicesTable = ({
  invoices,
}: {
  invoices: ContractTerms;
}): React.ReactElement => (
  <ContractTabTable
    values={invoices}
    columns={invoicesColumns as ColumnDefinition[]}
  />
);

export default InvoicesTable;
